module.exports = __webpack_public_path__ + "media/footer/youtube-194a3d1e.svg";